import { EReportsTabs } from '../types';

export const REPORTS_TABS = [
  { label: 'Financial', value: EReportsTabs.FINANCIAL },
  { label: 'Payouts', value: EReportsTabs.PAYOUTS }
];
